import { z } from 'zod';

import { i18n } from '~/utils';

/** Values the backend accepts for a company account's strategic multiplier (Fibonacci scale). */
export const STRATEGIC_MULTIPLIER_SCALE = [1, 2, 3, 5, 8, 13] as const;

export const DEFAULT_STRATEGIC_MULTIPLIER = 1;

export const STRATEGIC_MULTIPLIER_UNIT = '×';

export const zodStrategicMultiplierSchema = z.literal(
  STRATEGIC_MULTIPLIER_SCALE,
  {
    error: () =>
      i18n.t(($) => $.companyAccounts.strategicMultiplier.invalid, {
        ns: 'clients',
      }),
  },
);
